import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Router, { useRouter } from 'next/router';
import { HYDRATE } from 'next-redux-wrapper';
import type { HydrateAction } from 'redux-store/index';

interface Answers {
  [key: string]: string;
}

interface OnboardingType {
  isInit: boolean;
  steps: string[];
  currentPageUrl: string;
  nextPageUrl: string;
  backPageUrl: string;
  answers: Answers;
}

const initialState: OnboardingType = {
  isInit: false,
  steps: ['welcome'],
  currentPageUrl: 'welcome',
  nextPageUrl: '1-changes',
  backPageUrl: '',
  answers: {}
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    init: (state: OnboardingType, action: PayloadAction<{ steps: string[], currentPage?: string }>) => {
      let { steps, currentPage = '' } = action.payload;

      const route = Router.router?.route;
      
      if (!currentPage && route) {
        currentPage = route;
      }

      const currentPageIndex = steps.findIndex((item) => item.includes(currentPage));
      if (currentPageIndex !== -1) {
        const nextStepIndex = Math.min(currentPageIndex + 1, steps.length - 1);
        const backStepIndex = Math.max(currentPageIndex - 1, 0);

        const currentPageUrl = steps[currentPageIndex];
        const nextPageUrl = steps[nextStepIndex];
        const backPageUrl = steps[backStepIndex];

        return {
          ...state,
          isInit: true,
          steps,
          currentPageUrl,
          nextPageUrl,
          backPageUrl
        }
      }
    },
    goNext: (state) => {
      // const currentStepIndex = state.steps.indexOf(state.currentPageUrl);
      const currentStepIndex = state.steps.findIndex((item) => item.includes(state.currentPageUrl));

      const currentPageUrl = state.steps[currentStepIndex + 1];
      const nextPageUrl = state.steps[currentStepIndex + 2];
      const backPageUrl = state.steps[currentStepIndex];
      return {
        ...state,
        currentPageUrl,
        nextPageUrl,
        backPageUrl
      };
    },
    goBack: (state) => {
      const currentStepIndex = state.steps.findIndex((item) => item.includes(state.currentPageUrl));

      const currentPageUrl = state.steps[currentStepIndex - 1];
      const backPageUrl = state.steps[currentStepIndex - 2]
      const nextPageUrl = state.steps[currentStepIndex];
      
      return {
        ...state,
        currentPageUrl,
        backPageUrl,
        nextPageUrl
      };
    },
    setAnswer: (state, action: PayloadAction<{ screen: string, answer: string, isSaveLocal?: boolean }>) => {
      const { screen, answer, isSaveLocal = true } = action.payload;

      const stroredAnswers = localStorage.getItem('surveyAnswers');
      const surveyAnswers = stroredAnswers ? JSON.parse(stroredAnswers) : {};
      surveyAnswers[screen] = answer;
      if (isSaveLocal) {
        localStorage.setItem('surveyAnswers', JSON.stringify(surveyAnswers));
      }

      return {
        ...state,
        answers: {
          ...state.answers,
          [screen]: answer
        }
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: HydrateAction<OnboardingType>) => {
      if (action.payload.onboarding.isInit === false) {
        return {
          ...state,
        }
      }

      return {
        ...state,
        ...action.payload.onboarding,
      }
    });
  }
});

export const { init, goNext, goBack, setAnswer } = onboardingSlice.actions;
export default onboardingSlice.reducer;